module.exports = __webpack_public_path__ + "static/media/s20+_black.3a975ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/samsung-galaxy/s20+/s20+_black.png
// module id = 2199
// module chunks = 0